export class GroupSecurityPrivs {
    public topic: {
        read: boolean,
        write: boolean
    };

    public assignment: {
        read: boolean,
        write: boolean
    };

    public cost: {
        read: boolean,
        write: boolean
    };

    public viewUserLocationPrivileges: boolean = true;
    public privId: string;


    constructor() {
        this.topic = {
            read: true,
            write: true,
        }


        this.assignment = {
            read: true,
            write: true,
        }

        this.cost = {
            read: true,
            write: true,
        }
    }
}
